// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00487635","551":"0a8b068b","842":"fcce1f24"}[chunkId] + ".chunk.js";
};